module.exports = __webpack_public_path__ + "static/media/atlanta-brad.7e08c21b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/atlanta-brad.png
// module id = 90
// module chunks = 0